var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTenant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18H22.5851V20H0V18ZM2.25851 10H4.51702V17H2.25851V10ZM7.90479 10H10.1633V17H7.90479V10ZM12.4218 10H14.6803V17H12.4218V10ZM18.0681 10H20.3266V17H18.0681V10ZM0 5L11.2926 0L22.5851 5V9H0V5ZM11.2926 6C11.5921 6 11.8793 5.89464 12.0911 5.70711C12.3028 5.51957 12.4218 5.26522 12.4218 5C12.4218 4.73478 12.3028 4.48043 12.0911 4.29289C11.8793 4.10536 11.5921 4 11.2926 4C10.9931 4 10.7058 4.10536 10.4941 4.29289C10.2823 4.48043 10.1633 4.73478 10.1633 5C10.1633 5.26522 10.2823 5.51957 10.4941 5.70711C10.7058 5.89464 10.9931 6 11.2926 6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenant);
export default __webpack_public_path__ + "static/media/tenant.c56bffaf36aa96f6a175dad9aafcef09.svg";
export { ForwardRef as ReactComponent };